import { FD_IMAGE_URL } from '../../../constants'
import RenderHTML from '../../ui-components/RenderHTML'

type ChevronBoxPropTypes = {
  iconUrl: string
  text: string
  title?: string
  isActionable?: boolean
}

export const ChevronBox = ({ iconUrl, text, title, isActionable = true }: ChevronBoxPropTypes) => {
  return (
    <div className='border border-[#33A7E4] backdrop-blur-[27px] bg-white/3 rounded-2xl flex items-center px-5 py-4'>
      <div>
        <img src={iconUrl} />
      </div>
      <div className='pl-5 text-[#D1ECFF] text-[18px] font-[400] flex flex-1'>
        <div className='flex flex-col gap-1'>
          {title && <div className='text-white'>{title}</div>}
          <div>
            <RenderHTML innerHTMLText={text} />
          </div>
        </div>
      </div>
      {isActionable && (
        <div>
          <img src={`${FD_IMAGE_URL}/right-chevron-icon.svg`} />
        </div>
      )}
    </div>
  )
}
